import { render, staticRenderFns } from "./POIDetails.vue?vue&type=template&id=606c95e4&scoped=true&"
import script from "./POIDetails.vue?vue&type=script&lang=js&"
export * from "./POIDetails.vue?vue&type=script&lang=js&"
import style0 from "./POIDetails.vue?vue&type=style&index=0&id=606c95e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606c95e4",
  null
  
)

export default component.exports